const { connect, createLocalTracks } = require('twilio-video');

class SynchronousVideo {
  constructor(localMediaContainer, remoteMediaContainer) {
    this.room = null;
    this.observer = null;
    this.localVideoTrack = null;
    this.localAudioTrack = null;
    this.localMediaContainer = localMediaContainer;
    this.remoteMediaContainer = remoteMediaContainer;
  }

  subscribe(fn) {
    this.observer = fn;
  }

  publishScreenCapture(screenCaptureTrack) {
    this.room.localParticipant.unpublishTrack(this.localVideoTrack);
    this.room.localParticipant.publishTrack(screenCaptureTrack);
  }

  unpublishScreenCapture(screenCaptureTrack) {
    this.room.localParticipant.unpublishTrack(screenCaptureTrack);
    this.room.localParticipant.publishTrack(this.localVideoTrack);
  }

  handleMute(isMuted) {
    this.localAudioTrack.enable(isMuted);
  }

  endCall() {
    this.room.disconnect();
  }

  connect(token) {
    createLocalTracks({
      audio: true,
      video: true
    }).then(localTracks => {
      localTracks.forEach(track => {
        if (track.kind === 'video') {
          this.localVideoTrack = track;
        }
        else if (track.kind === 'audio') {
          this.localAudioTrack = track;
        }
        this.localMediaContainer.appendChild(track.attach());
      });

      return connect(token, {
        tracks: localTracks
      });
    }).then(room => {
      this.observer("Waiting for Patient");

      this.room = room;

      // Patient already in the room
      this.room.participants.forEach(participant => {
        this.observer(`${participant.identity} has joined`);

        participant.tracks.forEach(publication => {
          publication.on('subscribed', remoteTrack => {
            this.remoteMediaContainer.appendChild(remoteTrack.attach());
          });
          publication.on('unsubscribed', remoteTrack => {
            const mediaElements = remoteTrack.detach();
            mediaElements.forEach(mediaElement => mediaElement.remove());
          });
        });
        // Listen for future publish tracks
        participant.on('trackSubscribed', track => {
          this.remoteMediaContainer.appendChild(track.attach());
        });
        participant.on('trackUnsubscribed', track => {
          const mediaElements = track.detach();
          mediaElements.forEach(mediaElement => mediaElement.remove());
        });
      });

      this.room.on('participantConnected', participant => {
        this.observer(`${participant.identity} has joined`);

        // Listen for future publish tracks
        participant.on('trackSubscribed', track => {
          this.remoteMediaContainer.appendChild(track.attach());
        });
        participant.on('trackUnsubscribed', track => {
          const mediaElements = track.detach();
          mediaElements.forEach(mediaElement => mediaElement.remove());
        });
      });

      this.room.on('participantDisconnected', participant => {
        this.room.disconnect();
        window.close();
      });

      this.room.on('trackDisabled', publication => {
        const attachedElements = publication.track.detach();
        attachedElements.forEach(element => element.remove());
      })

      this.room.on('trackEnabled', publication => {
        this.remoteMediaContainer.appendChild(publication.track.attach());
      })

      this.room.on('disconnected', room => {
        this.room.localParticipant.tracks.forEach(publication => {
          const attachedElements = publication.track.detach();
          attachedElements.forEach(element => element.remove());
        });
      });
    });
  }
}

export default SynchronousVideo;